import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryAllowedEnvironments({ count, ...params }) {
  const url = count ? '/environment/allowed/count' : '/environment/allowed';
  return request(url, { params: toQuery(params) });
}

export async function queryAllowedSites(params) {
  return request('/processPortal/allowed', {
    params: toQuery({
      ...params,
      select: 'id,name,shortCode,description,logoUrl,faviconUrl',
      limit: 100,
    }),
  });
}

export async function queryChangeEnvironment({ id }) {
  return request.post(`/account/changeEnvironment/${id}`);
}

export async function queryCompanies({ count, ...params }) {
  const url = count ? '/company/allowed/count' : '/company/allowed';
  return request(url, { params: toQuery(params) });
}

export async function queryChangeCompany({ id, accessId, environmentId }) {
  return request.post(`/account/changeCompany/${id}/${accessId}`, {
    ...(environmentId && { params: { environmentId } }),
  });
}
